import { S3_BUCKET_URL } from '@/constants';

import { ScreenInteraction } from '../OwnAI/screens/Interaction';
import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';
import { ScreenAge } from '../OwnAIMultiGender/screens/Age';
import { ScreenBodyShape } from '../OwnAIMultiGender/screens/BodyShape';
import { ScreenCommunicate } from '../OwnAIMultiGender/screens/Communicate';
import { ScreenEthnicity } from '../OwnAIMultiGender/screens/Ethnicity';
import { ScreenFindAi } from '../OwnAIMultiGender/screens/FindAi';
import { ScreenGender } from '../OwnAIMultiGender/screens/Gender';
import { ScreenHairColor } from '../OwnAIMultiGender/screens/HairColor';
import { ScreenObedience } from '../OwnAIMultiGender/screens/Obedience';
import { ScreenSettingUpProfile } from '../OwnAIMultiGender/screens/SettingUpProfile';

import { ScreenAboutLook } from './screens/AboutLook';
import { ScreenEmail } from './screens/Email';
import { ScreenMajorTurnOff } from './screens/MajorTurnOff';
import { LayoutDataType } from './types';

export const layoutSteps = {
  gender: {
    component: ScreenGender,
    images: [],
  },
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  find_ai: {
    component: ScreenFindAi,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: [],
  },
  hair_color: {
    component: ScreenHairColor,
    images: [],
  },
  about_look: {
    component: ScreenAboutLook,
    images: [`${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`],
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [`${S3_BUCKET_URL}/layout-own-ai/modal_send_photos.png`],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  gender: null,
  age: null,
  ethnicity: null,
  body_shape: null,
  hair_color: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};
